import Field from '../../../model/refbooks/field';
import Fields from '../../../collection/refbooks/fields';
import Form from '../../form';
import View from "../../view";

import { asc, desc } from '../../../collection/sort';
import { ask } from '../../../utils/popups';
import { handle } from '../../../service/messages';
import { hashify } from '../../../utils/arrays';
import { error } from '../../../ui/messages';

import i18n from '../../../i18n';

let ifn; i18n.then( i => ifn = i );





export default View.extend( {

    // ???
    onBind(/*model*/) {
        this.options.sorted = new Fields();
        this.options.filtered = new Fields();
        this.options.resulted = new Fields();

        // todo? wait for sorting & filter
        this.sorting_ = this.reSort().then( () => this.reRenderGridRows() );

        this.listenTo( this.options.resulted, 'activate deactivate',
            () => this.Buttons.render() );
    },

    serialize() {
        // todo wait for current sorting & filter?
        // sorting is fast, but it's async now;
        // so we must wait until sorting in onBind finishes
        return this.sorting_.then( () => {
            const { resulted, } = this.options;

            return {
                rows: resulted, // subfields: fieldsFiltered

                dragMode: () => this.options.dragMode,

                rowsToSortCount: () => this.options.filtered.length,

                isOrderChanged: () => {
                    for (let subfield of this.model.get( 'subfields' ))
                        if (subfield['new-order'] != subfield['order'])
                            return true;
        
                    return false;
                }
            };
        } );
x   },

    events: {

        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;

            return this.options.page = 1, this.options.sort = sort, this.options.direction = direction,
                this.reSort().then( () => this.reRender() )
                    // hack: reRender() to do filtering, then render() to re-render grid header
                    .then( () => this.render() )
                    .then( () => this.trigger( 'sort', { sort, direction } ) );
        },

    },

    [View.event( 'Paging:page')](page) {
        return this.options.page = page, 
            this.reRender(),
            this.trigger( 'page', page );
    },

    [View.event( 'Search:search')](search) {
        return this.options.search = search, this.options.page = 1,
            this.reRender(),
            this.trigger( 'search', search );
    },

    [View.event( ':subfields:new' )]() {
        this.createSubfield();
    },

    [View.event( 'Grid:action:create')]() {
        if (!this.options.dragMode)
            this.createSubfield();
    },
    
    [View.event( ':subfields:edit' )]() {
        this.editSubfield();
    },

    [View.event( 'Grid:action:default')]() {
        if (!this.options.dragMode)
            this.editSubfield();
    },
    
    [View.event( ':subfields:remove' )]() {
        this.removeSubfield();
    },

    [View.event( 'Grid:action:destroy')]() {
        if (!this.options.dragMode)
            this.removeSubfield();
    },
    
    [View.event( 'Grid:swap-up')](index) {
        this.reorder( [+index, +index-1] );

        if (index == 0)
            this.options.page = this.options.resulted.page - 1;

        this.reSort( 'new-order', 'asc' )
            .then( () => this.reRender() );
    },

    [View.event( 'Grid:swap-down')](index) {
        this.reorder( [+index+1, +index] );

        if (index == this.options.resulted.length - 1)
            this.options.page = this.options.resulted.page + 1;

        this.reSort( 'new-order', 'asc' ).then( () => this.reRender() );
    },

    [View.event( 'Grid:rows:order' )](permutation) {
        this.reorder( permutation ); 

        this.reSort( 'new-order', 'asc' ).then( () => this.reRender() );
    },

    [View.event( ':subfields:sort' )]() {
        this.options.dragMode = true;
        // todo cpoy-pasted ??? need to iterate all clusters (options.source) because cluster filter
        // may be changing during sorting process
        this.model.get( 'subfields' )
            .forEach( model => model['new-order'] = model['order'] );
        
        this.options.page = 1;
        this.reSort( 'new-order', 'asc' ).then( () => this.reRender() );
    },

    [View.event( ':subfields:apply-sort' )]() {
        this.model.get( 'subfields' )
            .forEach( model => model['order'] = model['new-order'] );
        this.model.trigger( 'change' );

        this.options.dragMode = false;
        // then sort
        this.reSort().then( () => this.reRender() );
    },

    [View.event( ':subfields:cancel-sort' )]() {
        // drop drag-mode first
        this.options.dragMode = false;
        // then sort
        this.reSort().then( () => this.reRender() );
    },

    createSubfield() {
        createSubfield.call( this,
                // just array, not collection
                this.model.get( 'subfields' ) )
            .then( subfields => this.model.set( 'subfields', subfields ) )
            .then( () => this.reSort().then( () => this.reRender() ) );
    },

    editSubfield() {
        editSubfield.call( this,
                this.options.resulted.current(),
                // just array, not collection
                this.model.get( 'subfields' ) )
            .then( subfields => this.model.set( 'subfields', subfields ) )
            .then( () => this.reSort().then( () => this.reRender() ) )
            // to trigger buttons re-render if child-child model is changed;
            // listen(field, 'change') in form.template doesn' work
            .then( 
                () => this.model.trigger( 'change' ),
                () => this.model.trigger( 'change' ) );
    },

    removeSubfield() {
        const { resulted, page } = this.options;
        const current = resulted.current();

        ask( 'field::modal delete - confirmation text',
            'field::modal delete - title', 'actions::yes', 'actions::no',
            () => 
                this.model.set( 
                    'subfields', 
                    this.model.get( 'subfields' ).filter( el => el.id != current.id) ) )
                .then( () => {
                    if (resulted.length === 1 && page > 1)
                        this.options.page--;
                
                    this.reSort().then( () => this.reRender() );
                } );
    },

    // [newOrder = 3, 0 or 5, 7, 1]
    reorder(newOrder) {
        // index === value, old position
        // i     === pos,   new position
        // order: new position -> old position

        const { filtered, resulted } = this.options;
        const { page, limit } = resulted;
        const offset = (page - 1) * limit;
        newOrder = newOrder.map( index => index + offset );

        const usedIndexes = hashify( newOrder );

        const permutation = [];
        for (let i = 0; i < filtered.length; i++)
            permutation.push( usedIndexes[i] ? newOrder.shift() : i );

        const subfields = hashify( this.model.get( 'subfields' ), sf => [sf.id, sf] )
        const ids = filtered
            .models.map( model => model.id );
        permutation
            .map( (index, i) => [ids[index], ids[i]] )
            .map( ([idHere, prevIdHere]) => [subfields[idHere], subfields[prevIdHere]] )
            .map( ([modelHere, prevModelHere]) => [modelHere, prevModelHere[ 'new-order' ]] )
            .forEach( ([modelHere, prevOrderHere]) => 
                modelHere[ 'new-order' ] = prevOrderHere );

        return permutation;
    },

    reSort(sort, direction) {
        sort = sort || this.options.sort;
        direction = direction || this.options.direction;

        return this.sort( { sort, direction }, 
            this.model.get( 'subfields' ), this.options.sorted );
    },
    
    sort({ sort: sortField, direction }, source, dest) {
        sortField = sortField instanceof Array ? sortField : [sortField];
        const models = source.models || source;

        const sorting = 'asc' === direction
            ? asc( models, [...sortField, 'id'] )
            : desc( models, [...sortField, 'id'] );
    
        return sorting.then( sortedModels => dest.reset( sortedModels ) );
    },
    
    filter({ search, page, limit, cluster }, source, filtered, dest) {
        const searchString = search.toLowerCase();

        // todo check cluster
        const models = source.models
            .filter( model =>
                !cluster || !model.get( 'cluster' ) || model.get( 'cluster' ).id == cluster.id )
            .filter( model => ~(model.id + '').indexOf( searchString )
                || ~model.get( 'name' ).toLowerCase().indexOf( searchString ) );
    
        dest.total = filtered.total = models.length;
        dest.page = filtered.page = page;
        dest.limit = filtered.limit = limit;
        dest.npages = (dest.total / dest.limit | 0) + (dest.total % dest.limit == 0 ? 0 : 1);

        filtered.reset( models );
        dest.reset( models
            .filter( (_, index) => index >= limit * (page - 1) &&
                                   index <  limit * page ) );
    },

    reRenderGridRows() {
        const { search, sorted, filtered, resulted, page, limit } 
            = this.options;

        // todo wait for sort?
        // it seems - no; because reRender() is called in pair with sort/reSort + then
        this.filter( { search, page, limit }, 
            sorted, filtered, resulted );
    },
    
    reRender() {
        this.reRenderGridRows(); this.Buttons.render();
    },


} ); 





function createSubfield(subfieldArray) {
    const { types, is_for_all, cluster } = this.model.toJSON();
    const subfield = new Field( { types, is_for_all, cluster } );

    return openFieldForm.call( this, subfield, 'field::actions - new', 'actions::add' )
        .then( subfield => subfield.toJSON() )
        .then( ({ ...json, types, is_for_all, cluster }) => ({ 
            ...json, 
            // 1 + maxid
            id: 1 + 
                Math.max( 1000000000, ...subfieldArray.map( f => f.id ) ),
            // 1 + maxorder
            order: 1 + 
                Math.max( 0, ...subfieldArray.map( f => f.order ) ),
        }) )
        .then( subfield => [...subfieldArray, subfield] );
}

function editSubfield(subfieldModel, subfieldArray) {
    const { id, ...attrs } = subfieldModel.toJSON();
    const { types, is_for_all, cluster } = this.model.toJSON();
    const subfield = id < 1000000000
        ? new Field( { ...attrs, types, is_for_all, cluster, id } )
        : new Field( { ...attrs, types, is_for_all, cluster } );

    return openFieldForm.call( this, subfield, 'actions::edit', 'actions::apply' ) 
    .then( subfield => subfield.toJSON() )
    .then( ({ ...subfieldJson, types, is_for_all, cluster }) => ({ ...subfieldJson, id }) )
    .then( subfield => subfieldArray.map( json => 
            json.id == id ? subfield : json ) )
}

function openFieldForm(subfieldModel, popupLabel, applyLabel) {
    const extended = !subfieldModel.id || 
        ['composite', 'file'].includes( subfieldModel.get( 'format' ) );
        
    const binding = new Form( { 
            datatables: this.options.datatables, 
            stickers: this.options.stickers,
            types: this.options.types,

            stickersPage: 1, stickersSort: 'name', stickersDirection: 'asc', stickersSearch: '',

            template: extended
                ? 'module/refbooks/fields.form.subfield.composite'
                : 'module/refbooks/fields.form.subfield.simple',

            onBind(model) {
                this.listenTo( model, 'change',
                    () => this.$el.closest( '.modal' )
                        .find( '.action-accept' )[0].disabled = (console.log( 're-render accept btn' ), !this.hasDiff()) )

                // see fields.form.bound-stickers.js
                // cannot change cluster in nested model
        
                // see fields.form.bound-stickers.js
                this.listenTo( model, 'change:format', () => {
                    if (model.get( 'format' ) !== 'file' )
                        this.stickersPage = 1, this.stickersSort = 'name', this.stickersDirection = 'asc', this.stickersSearch = '';
                        // todo
                        // this.trigger( FieldFormTemplateModule.TOGGLE_BOUND_TYPES,
                        //         this.model,
                        //         this.originalModel,
                        //         this.state() );
                } );
            },

            // see fields.form.bound-stickers.js
            serialize() {
                const { 
                    stickersSort, stickersDirection, stickersSearch, stickersPage,
                } = this;

                return {
                    stickersSort, stickersDirection, stickersSearch, stickersPage,
                    tmp1: 1,
                };
            },

            [Form.event( 'Fields:file-semantics:toggle' )](passedSemantics) {
                const contains = this.model.get( 'file_semantics' ).includes( passedSemantics );
                const newSemantics = contains
                    ? this.model.get( 'file_semantics' ).filter( ft => ft !== passedSemantics )
                    : [...this.model.get( 'file_semantics' ), passedSemantics];
                this.model.set( 'file_semantics', newSemantics );
            },

            // see fields.form.bound-stickers.js
            [Form.event( 'Stickers:page')](page) {
                return this.stickersPage = +page;
            },
        
            // see fields.form.bound-stickers.js
            [Form.event( 'Stickers:sort')]({ sort, direction }) {
                return this.stickersSort = sort, this.stickersDirection = direction;
            },
        
            // see fields.form.bound-stickers.js
            [Form.event( 'Stickers:search')](search) {
                return this.stickersSearch = search, this.stickersPage = 1;
            },
        
        } ).bind( subfieldModel );

    return ask( binding, popupLabel, applyLabel, 'actions::cancel', 
        { 
            large: extended,
            afterRender(ctx, firstTime) {
                if (firstTime)
                    this.$( '.action-accept' )[0].disabled = true;
            }
        }, 
        () => {
            if (!subfieldModel.get( 'name' ).trim())
                return handle( binding.view, error( [ifn( 'forms::required field' ), 'name'] ) ), 
                    false;
        } )
        .then( () => subfieldModel );
}


// WEBPACK FOOTER //
// ./src/js/view/module/refbooks/fields.form.subfields.grid.js